import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-recruiter-sidebar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './recruiter-sidebar.component.html',
  styleUrls: ['./recruiter-sidebar.component.scss']
})
export class RecruiterSidebarComponent {
  @Input() isCollapsed = false;
  @Input() activeTab = 'dashboard';

  @Output() activeTabChange = new EventEmitter<string>();
  @Output() toggleCollapse = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();

  selectTab(tab: string): void {
    this.activeTabChange.emit(tab);
  }

  onToggleCollapse(): void {
    this.toggleCollapse.emit();
  }

  onLogout(): void {
    this.logout.emit();
  }
}
